export default "__VITE_ASSET__0c69910c__"